<script>
import Vue from 'vue'
import { GlobalBus } from '@services/bus'
import { MODAL, ACTION } from '@constants/Text'
import apiBiProfissionais from '@api/bi/biProfissionais'

export default {
  name: 'ModalTransferirConversa',
  props: {
    // Namespace do store + chaves GlobalBus — default atendimento.
    // Solicitacoes injeta o seu namespace e as chaves MODAL/ACTION disjuntas.
    namespace: {
      type: String,
      default: 'atendimento',
    },
    openKey: {
      type: String,
      default: MODAL.ATENDIMENTO_TRANSFERIR_CONVERSA,
    },
    transferidaKey: {
      type: String,
      default: ACTION.ATENDIMENTO_CONVERSA_TRANSFERIDA,
    },
  },
  data() {
    return {
      busModal: new Vue(),
      loading: false,
      idConversa: null,
      selectedProfissional: null,
      nota: '',
      mode: 'transferir',
    }
  },
  computed: {
    profissionais() {
      return [...(this.$store.getters['bi/sortedProfessionalsActives'] || [])]
    },
    profissionalOptions() {
      return this.profissionais.map((p) => ({
        text: p.nome || 'Profissional #' + p.id_profissional,
        value: p.id_profissional,
      }))
    },
    isTransferMode() {
      return this.mode === 'transferir'
    },
    canConfirm() {
      if (this.isTransferMode) {
        return !!this.selectedProfissional
      }
      return true
    },
    modalTitle() {
      return this.isTransferMode ? 'Transferir Conversa' : 'Escalar Conversa'
    },
    confirmLabel() {
      return this.isTransferMode ? 'Transferir' : 'Escalar'
    },
  },
  created() {
    GlobalBus.$on(this.openKey, this.open)
  },
  beforeDestroy() {
    GlobalBus.$off(this.openKey, this.open)
  },
  methods: {
    clear() {
      this.loading = false
      this.idConversa = null
      this.selectedProfissional = null
      this.nota = ''
      this.mode = 'transferir'
    },

    open(params) {
      this.clear()
      if (params) {
        this.idConversa = params.id_conversa || null
        this.mode = params.mode || 'transferir'
      }
      this.busModal.$emit('dialog', true)
      this.$nextTick(() => this.fetchProfissionais())
    },

    fetchProfissionais() {
      if (!this.isTransferMode) return
      apiBiProfissionais.carregar()
    },

    async confirm() {
      if (this.loading) return
      if (!this.canConfirm) return

      this.loading = true
      try {
        let r
        if (this.isTransferMode) {
          r = await this.$store.dispatch(`${this.namespace}/transferirConversa`, {
            id_conversa: this.idConversa,
            para_profissional_id: this.selectedProfissional,
            nota: this.nota,
          })
        } else {
          r = await this.$store.dispatch(`${this.namespace}/escalarConversa`, {
            id_conversa: this.idConversa,
            nota: this.nota,
          })
        }

        this.$showSnack({
          text: (r && r.message) || 'Erro inesperado',
          color: r && r.status === 200 ? 'success' : 'error',
          button: true,
        })
        if (r && r.status === 200) {
          this.busModal.$emit('dialog', false)
          GlobalBus.$emit(this.transferidaKey)
        }
      } finally {
        this.loading = false
      }
    },
  },
}
</script>

<template>
  <BaseModal
    centerScreen
    :bus="busModal"
    persistent
    centerAndDecreasesPadding
    maxWidth="45%"
    closeColor="#8e8e8e"
    backgroundColor="white"
  >
    <div class="pb-6">
      <div class="modal-title-container">
        <span class="modal-title">{{ modalTitle }}</span>
      </div>

      <div class="modal-content">
        <div class="pa-4">
          <!-- Professional selector (transfer mode only) -->
          <input-by-type
            v-if="isTransferMode"
            v-model="selectedProfissional"
            type="autocomplete"
            :options="profissionalOptions"
            labelExternal="Selecionar profissional"
            class="align-icon-search mb-4"
            dense
            hide-details
            data-test="profissional-select"
            style="min-width: 175px"
          />

          <!-- Nota field -->
          <input-by-type
            v-model="nota"
            type="textarea-new-ux"
            :labelExternal="
              isTransferMode
                ? 'Nota para o profissional (opcional)'
                : 'Motivo da escalada (opcional)'
            "
            rows="3"
            data-test="nota-field"
          />
        </div>

        <v-divider class="my-4" />
      </div>
    </div>

    <template v-slot:actions="{ close }">
      <BaseButton underlined @click="close"> Cancelar </BaseButton>
      <BaseButton
        primary
        :loading="loading"
        :disabled="loading || !canConfirm"
        data-test="confirm-btn"
        @click="confirm"
      >
        {{ confirmLabel }}
      </BaseButton>
    </template>
  </BaseModal>
</template>
